export const PrivacyAndCookiePolicy = {
    policyDocument: {
        title: 'Privacy and Cookie Policy',
        effectiveDate: '2026-06-17',
        introduction:
            'Welcome to my personal portfolio, as part of my principle for our human right to privacy, I\'m providing you with my privacy and cookie policy for this website.',
        sections: [
            {
                id: 'data-collection',
                title: '1. Personal Data Collection',
                body: 'This website is intended for informational purposes only. I do not collect, store, process, or share any personal information from my visitors. You can browse this site completely anonymously.',
            },
            {
                id: 'cookies',
                title: '2. Cookies and Tracking Technologies',
                body: 'I do not use cookies, web beacons, analytics trackers, or any similar tracking technologies on this website. Your browsing behavior and device information are not monitored or recorded by this site.',
            },
            {
                id: 'third-party-links',
                title: '3. External Links',
                body: 'My portfolio may contain links to external websites, such as LinkedIn, GitHub, or my live project demonstrations. I have no control over the privacy practices or content of these external sites. Once you leave my portfolio, I encourage you to read the privacy policies of any website you visit.',
            },
            {
                id: 'policy-updates',
                title: '4. Changes to This Policy',
                body: 'Because this site does not collect data, I do not anticipate frequent changes to this policy. However, if I ever add features that require data collection or cookies in the future, I will update this page to reflect those changes.',
            },
            {
                id: 'contact',
                title: '5. Contact Information',
                body: 'If you have any questions or concerns regarding this policy, please feel free to reach out to me through the contact methods provided on the website.',
            },
        ],
    },
};
